import { render, staticRenderFns } from "./ChangeOrganisation.vue?vue&type=template&id=7a3d324a&scoped=true&"
import script from "./ChangeOrganisation.vue?vue&type=script&lang=js&"
export * from "./ChangeOrganisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3d324a",
  null
  
)

export default component.exports